import { render, staticRenderFns } from "./ModalParent.vue?vue&type=template&id=c324c470&scoped=true"
import script from "./ModalParent.vue?vue&type=script&lang=js"
export * from "./ModalParent.vue?vue&type=script&lang=js"
import style0 from "./ModalParent.vue?vue&type=style&index=0&id=c324c470&prod&scoped=true&lang=css"
import style1 from "./ModalParent.vue?vue&type=style&index=1&id=c324c470&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c324c470",
  null
  
)

export default component.exports